module.exports = __webpack_public_path__ + "img/qijian-dingdan.460d7b82.svg";